import React from 'react';
import { View } from 'react-native';
import { styled } from 'dripsy';
import { useModal } from 'react-native-modalfy';
import { useNavigation } from '@react-navigation/native';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import {
  AvatarImage,
  BaseText,
  Line,
  Separator,
  Touchable,
  TouchableTypeEnum,
} from '@components';
import { modals, ModalStackParamsType } from '@modals';
import { IS_WEB } from '@utils';
import {
  HomeTabNavigatorNavigationPropType,
  screens,
} from '@navigation';
import { useViewerModel } from '@models/Viewer/ViewerModel';

const Container = styled(View)({
  width: '100%',
});

const TouchableContainer = styled(Touchable)({
  flexDirection: 'row',
});

const TextContainer = styled(View)({
  flex: 1,
  justifyContent: 'center',
});

const Text = styled(BaseText)({
  color: '$text80',
  variant: 'text.medium',
});

type NavigationRoutePropType =
  HomeTabNavigatorNavigationPropType<'News'>;

export const PostEditorButton = observer(() => {
  const modal = useModal<ModalStackParamsType>();
  const nav = useNavigation<NavigationRoutePropType>();
  const viewer = useViewerModel();
  const { t } = useTranslation();

  function navigateToPostEditor() {
    if (IS_WEB) {
      modal.openModal(modals.PostEditorModal);
    } else {
      nav.navigate(screens.PostNavigator, {
        screen: screens.PostEditor,
      });
    }
  }

  return (
    <Container>
      <TouchableContainer
        onPress={navigateToPostEditor}
        type={TouchableTypeEnum.Opacity}
        hitSlop={30}
      >
        <AvatarImage
          size={36}
          source={{ uri: viewer.currentUser?.photo.small?.url }}
        />
        <Separator size="$5" vertical />
        <TextContainer>
          <Text>{t('home.whatsOnYourMind')}</Text>
          <Separator size="$1" />
          <Line color="$background50" />
        </TextContainer>
      </TouchableContainer>
    </Container>
  );
});
